ALLOWED_CONTROLLER = 'access_hubs'
ALLOWED_ACTIONS = ['index']

ready = ->
  return unless continueIfAllowed(ALLOWED_CONTROLLER, ALLOWED_ACTIONS)
  accessHubsTable = $('#access_hubs').dataTable
    sPaginationType: "full_numbers"
    bJQueryUI: true
    bProcessing: true
    bServerSide: true
    iDisplayLength: 50
    sAjaxSource: $('#access_hubs').data('source')
    order: [ [ 0, "asc" ] ]
    bAutoWidth: false
    fixedColumns: true
    aoColumnDefs: [
      { bSortable: false, aTargets: [ 2, 4, 6, 7, 8, 9, 10, 11 ] },
      { sWidth: '75px', targets: 0 }
      { sWidth: '70px', targets: 1 }
      { sWidth: '80px', targets: 2 }
      { sWidth: '120px', targets: 3 }
      { sWidth: '64px', targets: 4 }
      { sWidth: '64px', targets: 5 }
      { sWidth: '160px', targets: 6 }
      { sWidth: '160px', targets: 7 }
      { sWidth: '70px', targets: 8 }
      { sWidth: '90px', targets: 9 }
      { sWidth: '76px', targets: 10 }
      { sWidth: '60px', targets: 11 }
      { sWidth: '130px', targets: 12 }
    ]

  selectAllButton()
  updateFirmwaresListener(accessHubsTable)
  updateDSFirmwaresListener(accessHubsTable)
  sendDSConfigurationsListener(accessHubsTable)
  updateAHCoreSoftwaresListener(accessHubsTable)
  updateAHGuiSoftwaresListener(accessHubsTable)

$(document).ready(ready)

selectAllButton = ->
  $('*[data-selector="select_all_access_hubs"]').on 'click', (e) ->
    unless $('[data-selector="select_all_access_hubs"]').prop('checked')
      $('input[data-selector="access_hub_checkbox"]').prop('checked', false)
    else
      $('input[data-selector="access_hub_checkbox"]').prop('checked', true)

collectCheckedIds = ->
  ids = []
  $('[data-selector="access_hub_checkbox"]').each (index, element) ->
    ids.push(element.id) if element.checked
  ids

runAjaxAction = (ajaxUrl, datatable) ->
  ids = collectCheckedIds()

  if ids.length > 0
    if confirm('Are you sure?')
      $.ajax(
        url: ajaxUrl
        dataType: 'json'
        data: {
          ids: ids
        }
        beforeSend: () ->
          $('#access_hubs_processing').css('display', 'block')
        success: (data, textStatus, jqXHR) ->
          $('[data-selector="select_all_access_hubs"]').prop('checked', false)
          alert(resultText(data))
          datatable.fnDraw()
        error: (jqXHR, textStatus, errorThrown) ->
          console.log(textStatus)
      )
  else
    alert("First you have to select some access hubs.")

resultText = (data) ->
  text = success_text(data.success)
  if data.errors.length > 0
    text += errors_text(data.errors)
  text

errors_text = (errors) ->
  number = errors.length
  text = "\n\n#{number} "
  if number == 1
    text += "device was not updated!"
  else
    text += "devices were not updated!"
  if number > 0
    text += "\nIDs: "
    text += errors.join(', ')
  text

success_text = (successes) ->
  number = successes.length
  text = "#{number} "
  if number == 1
    text += "device was updated"
  else
    text += "devices were updated"
  if number > 0
    text += "\nIDs: "
    text += successes.join(', ')
  text

updateFirmwaresListener = (datatable) ->
  $('a[data-selector="update_firmwares"]').on 'click', (e) ->
    e.preventDefault()
    runAjaxAction("/access_hubs/update_firmwares", datatable)

updateDSFirmwaresListener = (datatable) ->
  $('a[data-selector="update_ds_firmwares"]').on 'click', (e) ->
    e.preventDefault()
    runAjaxAction("/access_hubs/update_ds_firmwares", datatable)

sendDSConfigurationsListener = (datatable) ->
  $('a[data-selector="send_ds_configurations"]').on 'click', (e) ->
    e.preventDefault()
    runAjaxAction("/access_hubs/send_ds_configurations", datatable)

updateAHCoreSoftwaresListener = (datatable) ->
  $('a[data-selector="update_ah_core_softwares"]').on 'click', (e) ->
    e.preventDefault()
    runAjaxAction("/access_hubs/update_core_softwares", datatable)

updateAHGuiSoftwaresListener = (datatable) ->
  $('a[data-selector="update_ah_gui_softwares"]').on 'click', (e) ->
    e.preventDefault()
    runAjaxAction("/access_hubs/update_gui_softwares", datatable)

